import React, { useContext, useState } from 'react';
import { Link } from 'gatsby';
import { FirebaseContext } from '../../context/FirebaseContext';
import { StoreContext } from '../../context/StoreContext';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import firebase from 'gatsby-plugin-firebase';

import { SINGLE_PRODUCT_QUERY } from './mutations';

import WishlistAddToCart from './wishlist-add-to-cart';

import HeartIcon from '../../images/icons/heart.inline.svg';

const WishlistGridItemContainer = styled.div`
    margin-bottom: 70px;
    display: flex;
    .inner-wrap {
        flex: 1;
        max-width: 300px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        > * {
            flex: 1 1 100%;
        }
        a {
            text-decoration: none;
        }
        .image-container {
            margin-bottom: 20px;
            position: relative;

            .icon-container {
                position: absolute;
                top: 10px;
                right: 10px;

                button {
                    line-height: 1;
                    background-color: transparent;
                    border: none;
                    svg {
                        width: 23px;
                        height: 23px;
                        fill: #f74d33;
                        stroke: #f74d33;
                    }

                    &:hover {
                        svg {
                            fill: #fff;
                        }
                    }
                }
            }
        }

        .content-container {
            display: inline-flex;
            flex-wrap: wrap;
            > * {
                flex: 1 1 100%;
            }

            .inner-wrap {
                display: flex;
                align-items: flex-end;

                .variants {
                    margin: 0px 0 15px;

                    p {
                        color: #777;
                        font-size: 0.8rem;
                        margin: 0 auto;
                    }
                }

                .color-swatches-container {
                    margin-bottom: 5px;
                    ul {
                        padding: 0;
                        margin: 0;
                        list-style: none;
                        li {
                            display: inline-block;
                            margin-right: 10px;

                            &:last-child {
                                margin-right: 0px;
                            }

                            button {
                                height: 22px;
                                width: 22px;
                                border-radius: 50%;
                                border: 1px solid #ccc;
                                background-color: #888;

                                &.red {
                                    background-color: red;
                                }
                                &.black {
                                    background-color: black;
                                }

                                &.blue {
                                    background-color: blue;
                                }
                                &.green {
                                    background-color: green;
                                }
                                &.charcoal {
                                    background-color: #222;
                                }
                                &.orange {
                                    background-color: orange;
                                }
                                &.yellow {
                                    background-color: orange;
                                }
                                &.white {
                                    background-color: white;
                                }

                                &.navy {
                                    background-color: navy;
                                }

                                &.purple {
                                    background-color: purple;
                                }
                            }
                        }
                    }
                }

                a {
                    .title-container {
                        display: flex;
                        margin-bottom: 0px;
                        h4 {
                            flex: 3;
                            color: #000;
                            margin: 0;
                            line-height: 1.3;
                        }
                        p {
                            flex: 1;
                            text-align: right;
                            margin: 0;
                            color: #0f1212;
                        }
                    }
                }
            }
        }
    }
`;

const WishlistGridItem = ({ handle, variant, itemId }) => {
    // let token = JSON.parse(localStorage.getItem('cid')).token;

    const { loading, error, data } = useQuery(SINGLE_PRODUCT_QUERY, {
        variables: { handle: handle },
    });

    const { user } = useContext(FirebaseContext);

    const [currentVariant, setCurrentVariant] = useState();
    const [currentProduct, setCurrentProduct] = useState({});

    useEffect(() => {
        const product = data && data.productByHandle;
        let firstVariant = [];
        product &&
            product.variants.edges.length > 0 &&
            product.variants.edges.map((variantNode) => {
                let productVariant = variantNode.node;
                if (productVariant.id === variant.shopifyId) {
                    return firstVariant.push(productVariant);
                }
            });

        setCurrentVariant(firstVariant[0]);
        setCurrentProduct(product);
    }, [data]);

    const { image, priceV2, id } = currentVariant || {};
    const { title } = currentProduct || {};

    function removeItemFromWishist(itemId) {
        // console.log('users/' + user.id + '/wishlist/' + itemId);
        firebase
            .database()
            .ref('users/' + user.id + '/wishlist/')
            .child(itemId)
            .remove();
    }

    return (
        <WishlistGridItemContainer>
            <div className="inner-wrap">
                {image && (
                    <div className="image-container">
                        <Link href={`/products/${handle}`}></Link>
                        <img
                            src={currentVariant.image.originalSrc}
                            alt={title + ' ' + currentVariant.title}
                        />
                        <div className="icon-container">
                            <button
                                onClick={() => removeItemFromWishist(itemId)}
                            >
                                <HeartIcon />
                            </button>
                        </div>
                    </div>
                )}
                <div className="content-container">
                    <div className="inner-wrap">
                        <Link href={`/products/${handle}`}>
                            <div className="title-container">
                                <h4>{title}</h4>
                                {priceV2 && <p>${priceV2.amount}</p>}
                            </div>
                            <div className="variants">
                                {currentVariant &&
                                    currentVariant.selectedOptions &&
                                    currentVariant.selectedOptions.map(
                                        (option) => {
                                            return (
                                                <p>
                                                    <strong>
                                                        {option.name}
                                                    </strong>
                                                    : {option.value}
                                                </p>
                                            );
                                        }
                                    )}
                            </div>
                        </Link>
                        <WishlistAddToCart variantId={id} />
                    </div>
                </div>
            </div>
        </WishlistGridItemContainer>
    );
};

export default WishlistGridItem;
